export enum ProfileMatchSelectionTypeEnum {
    TotaleProfiel = "TotaleProfiel",
    AlleenTestResultaatEigenschappen = "AlleenTestResultaatEigenschappen"
}
